import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

function useSimplyTeam() {
	const user = useSelector(({ auth }) => auth.user);
	const [sb, setSb] = useState(null);
	const [loadingSb, setLoadingSb] = useState(true);

	useEffect(() => {
		if (user?.role !== '') {
			switch (user.role.toUpperCase()) {
				case 'CLIENT':
					setSb(false);
					break;
				case 'ANALYST':
				case 'MANAGER':
				case 'ADMIN':
					setSb(true);
					break;
				default:
					setSb(false);
					break;
			}
			setLoadingSb(false);
		} else {
			setLoadingSb(true);
		}
	}, [user]);

	return { sb, loadingSb };
}

export default useSimplyTeam;
